module.exports = __webpack_public_path__ + "static/media/feature02_upgrade.57b0dbf.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/feature02_upgrade.mp4
// module id = vGi+
// module chunks = 1